import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const StarFillIcon = React.memo<IconProps>(
  ({ className = '', size = 24, color = '#F59E0B', onClick, strokeWidth }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 11 11"
    >
      <path
        d="M10.7064 3.87305C10.6053 3.56225 10.3421 3.33495 10.0203 3.2803L7.39144 2.8306L6.15119 0.4695L6.15169 0.46925C5.99934 0.1797 5.70199 0 5.37484 0H5.37434C5.04744 0.00025 4.75009 0.1802 4.59824 0.4695L3.35849 2.8306L0.729592 3.2803C0.407092 3.3355 0.144142 3.563 0.0430919 3.87405C-0.0577581 4.1851 0.0213419 4.5237 0.249642 4.75785L2.11219 6.66655L1.72719 9.3057C1.68009 9.62945 1.81509 9.95025 2.07999 10.1422C2.23309 10.2535 2.41324 10.3101 2.59489 10.3101C2.72744 10.3101 2.86049 10.2799 2.98429 10.2188L5.37489 9.03715L7.76549 10.2183C8.05944 10.3638 8.40514 10.335 8.66979 10.1422C8.93444 9.94975 9.06969 9.62945 9.02234 9.3057L8.63804 6.66655L10.5003 4.7576C10.7288 4.5232 10.8079 4.1843 10.7064 3.87305Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

StarFillIcon.displayName = 'StarFillIcon';
